import React from 'react';
import _ from 'lodash';
import { Box, Grid, Typography } from '@mui/material';

const BellCurveBarSummary = ({ list = [], studentMark = NaN, barDisplay = false, isCluster = false,quizPercentile=NaN }) => {
  if (!list.length || !isFinite(studentMark)) return <p>No data available.</p>;
  const isMobile = window.innerWidth < 600;

    const numericMarks = list
    .filter(score => score !== null && score !== undefined)
    .map(Number);

  const maxMark = _.max(numericMarks);
  const minMark = _.min(numericMarks);

  // Calculate percentile rank using the standard formula
  const countBelow = numericMarks.filter(score => score < studentMark).length;
  const countEqual = numericMarks.filter(score => score == studentMark).length;

  const percentile = _.round(
    ((countBelow + 0.5 * countEqual) / numericMarks.length) * 100,
    2
  );

  // Additional metrics
  const percentScore = (studentMark / maxMark) * 100;
  const minMarkPercent = (minMark / maxMark) * 100;

  return (
    <div style={{ padding: '0.5rem', fontFamily: 'Montserrat' }}>
      {barDisplay ? (
        <>
          {isCluster ? (
            // Vertical Bar Display
            <div style={{ position: 'relative', height: '150px', width: '40px', background: '#eee', borderRadius: '8px', margin: 'auto', marginBottom: '12px' }}>
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  height: `${percentScore}%`,
                  width: '100%',
                  background: '#7CD181',
                  transition: 'height 0.3s ease-in-out',
                  borderRadius: '8px 8px 0 0',
                }}
              />
              {studentMark > 0 && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: `${percentScore}%`,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap',
                    marginBottom: '4px',
                    color: '#333',
                    zIndex: 2,
                  }}
                >
                  {studentMark}% marks
                </div>
              )}

              <div
                style={{
                  position: 'absolute',
                  bottom: `${minMarkPercent}%`,
                  left: 0,
                  width: '100%',
                  height: '2px',
                  backgroundColor: 'red',
                  zIndex: 1,
                }}
                title={`Min marks: ${minMark}%`}
              />
            </div>
          ) : (
            // Horizontal Bar Display (default)
            <div style={{ position: 'relative', background: '#eee', height: '32px', borderRadius: '8px', overflow: 'visible', marginTop: '12px' }}>
              <div
                style={{
                  width: `${percentScore}%`,
                  height: '100%',
                  background: '#7CD181',
                  transition: 'width 0.3s ease-in-out',
                }}
              />

              {studentMark > 0 && !isMobile && (
                <div
                  style={{
                    position: 'absolute',
                    left: `${percentScore}%`,
                    top: '-30px',
                    transform: 'translateX(-50%)',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#333',
                    whiteSpace: 'nowrap',
                    zIndex: 2,
                  }}
                >
                  🧑 {studentMark}% marks ({quizPercentile}%ile)
                </div>
              )}

              <div
                style={{
                  position: 'absolute',
                  left: `${minMarkPercent}%`,
                  top: '0',
                  bottom: '0',
                  width: '2px',
                  backgroundColor: 'red',
                  zIndex: 1,
                }}
                title={`Min marks: ${minMark}%`}
              />
            </div>
          )}
        </>
      ) : null}

<Grid item xs={12} sx={{ marginTop: '8px' }}>
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      rowGap: 1,
      columnGap: 2,
      flexDirection: { xs: 'column', sm: 'row' },
    }}
  >
    <Typography fontFamily="Montserrat" variant="body2" sx={{ flex: { xs: '1 0 100%', sm: 1 } }}>
      <strong>🎯 Your Marks:</strong> {studentMark}%
    </Typography>
    <Typography fontFamily="Montserrat" variant="body2" sx={{ flex: { xs: '1 0 100%', sm: 1 } }}>
      <strong>📈 Your Percentile:</strong> {quizPercentile}%ile
    </Typography>
    <Typography fontFamily="Montserrat" variant="body2" sx={{ flex: { xs: '1 0 100%', sm: 1 } }}>
      <strong>🟢 Highest Marks:</strong> {maxMark}%
    </Typography>
    <Typography fontFamily="Montserrat" variant="body2" sx={{ flex: { xs: '1 0 100%', sm: 1 } }}>
      <strong>🔻 Lowest Marks:</strong> {minMark}%
    </Typography>
  </Box>
</Grid>

    </div>
  );
};

export default BellCurveBarSummary;
